import React, { useEffect, useRef, useState } from "react";

import "./App.scss";
import "./Profile.scss";

import AvatarEditor from "react-avatar-editor";

import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faCheck, faXmark, faList } from "@fortawesome/free-solid-svg-icons";
import { ServerInterface } from "./ServerInterface";

import { _common } from "./common";
const common = _common;

function ProfilePictureEditor(props: { imageSrc: string; setImageAdjustedSrc: (v: string) => void; setAvatarEditActive: (v: boolean) => void }) {
  const { imageSrc, setAvatarEditActive, setImageAdjustedSrc } = props;
  const [scale, setScale] = useState(1.2);

  const editor = useRef(null);

  return (
    <div style={{ position: "relative", display: "flex", flexDirection: "column" }} tabIndex={1}>
      <AvatarEditor
        ref={editor}
        image={imageSrc}
        width={250}
        height={250}
        borderRadius={125}
        border={50}
        color={[11, 83, 80, 0.5]}
        // color={[255, 255, 255, 0.6]} // RGBA
        scale={scale}
        rotate={0}
      />
      <br />

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          paddingLeft: "40px",
          paddingRight: "40px",
        }}
      >
        Zoom: &nbsp;
        <input
          style={{ flexGrow: "1" }}
          name="scale"
          type="range"
          onChange={(ev) => {
            const s = parseFloat(ev.target.value);
            setScale(s);
          }}
          min="1"
          max="5"
          step="0.01"
          defaultValue="1"
        />
      </div>
      <br />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "20px",
          paddingRight: "40px",
        }}
      >
        <div
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "15px",
            backgroundColor: "orange",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            setAvatarEditActive(false);
          }}
        >
          <FontAwesomeIcon
            style={{
              color: "#444",
            }}
            icon={faXmark}
          />
        </div>
        <div
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "15px",
            backgroundColor: "orange",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            if (editor.current) {
              const canvas = (editor.current as any).getImage();
              const dataURL1 = canvas.toDataURL();

              const canvasScaled = (editor.current as any).getImageScaledToCanvas();

              const dataURL = canvasScaled.toDataURL();
              setImageAdjustedSrc(dataURL);
            }
            setAvatarEditActive(false);
          }}
        >
          <FontAwesomeIcon
            style={{
              color: "#444",
            }}
            icon={faCheck}
          />
        </div>
      </div>
    </div>
  );
}

// async function imageUrlToBase64(url: string): Promise<string> {
//   const response = await fetch(url);
//   const blob = await response.blob();
//   return new Promise((onSuccess, onError) => {
//     try {
//       const reader = new FileReader();
//       reader.onload = function () {
//         onSuccess(this.result as string);
//       };
//       reader.readAsDataURL(blob);
//     } catch (e) {
//       onError(e);
//     }
//   });
// }

export default function RegisterLangingPage(props: {}) {
  const navigate = useNavigate();

  const [imageSrc, setImageSrc] = useState<string>("");
  const [avatarEditActive, setAvatarEditActive] = useState(false);
  const [imageAdjustedSrc, setImageAdjustedSrc] = useState<string>("");
  const [imageNotFound, setImageNotFound] = useState(false);
  const [imageLoadedFromServer, setImageLoadedFromServer] = useState(false);

  const [initials, setInitials] = useState("??");

  const [errorEmail, setErrorEmail] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [errorFirstName, setErrorFirstName] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [errorPassword2, setErrorPassword2] = useState(false);
  const [errorTelefonNumber, setErrorTelefonNumber] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [enableBack, setEnableBack] = useState(false);


  useEffect(() => {

    const xedit = window.location.search.indexOf("edit") >= 0;

    const user = JSON.parse(common.getUserFromLocalStorage());
    const src = `${ServerInterface.serverUrl}/booking/profileImage/?memberId=${user.memberId}`;

    if (!xedit) {
      if (src) {
        return navigate("/booking");
      }
    } else {
      setEnableBack(true);
    }

    setImageSrc(src);
    setImageAdjustedSrc(src);


    setImageNotFound(false);
    setImageLoadedFromServer(true);


  }, []);

  function onImageLoadChange(ev: any) {
    const fileList = ev.target.files;
    if (fileList && fileList.length == 1) {
      let file = null;

      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].type.match(/^image\//)) {
          file = fileList[i];
          break;
        }
      }

      if (file !== null) {
        const src = URL.createObjectURL(file);

        convertImage(src).then((result: string) => {
          resizeImage(result, 250, 250).then((result1: string) => {
            setImageSrc(src);
            setImageNotFound(false);
            setImageLoadedFromServer(false);
            setImageAdjustedSrc(result1);
            setAvatarEditActive(true)

          });
        });
      }
    }
  }

  function getData(allowEmpty: boolean): any {
    const res: any = {
      // mode: mode,
      // orgId: orgId,
      // userId: userId,
      img: imageAdjustedSrc,
      firstName: (document.getElementById("firstName") as HTMLInputElement)?.value.trim(),
      lastName: (document.getElementById("lastName") as HTMLInputElement)?.value.trim(),
      email: (document.getElementById("email") as HTMLInputElement)?.value.trim(),
      telefonNumber: (document.getElementById("telefonNumber") as HTMLInputElement)?.value.trim(),
      password: (document.getElementById("password") as HTMLInputElement)?.value.trim(),
      password2: (document.getElementById("password2") as HTMLInputElement)?.value.trim(),
    };

    const validateEmail =
      String(res.email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ||
      (res.email == "" && allowEmpty);

    const validateTelefonNumber =
      String(res.telefonNumber)
        .toLowerCase()
        //.match(/^(?:\+\d\d\s\d\d\d\s\d\d\d|0\d\d\d{6,14}[0-9]$/) ||
        .match(/^(\+|0)[0-9,\ ]*$/) ||
      (res.email == "" && allowEmpty);

    if (!validateEmail) {
      res.error_email = true;
      res.error = true;
    }

    if (!validateTelefonNumber) {
      res.error_telefonNumber = true;
      res.error = true;
    }

    if (res.firstName.length < 3 && !(allowEmpty && res.firstName == "")) {
      res.error_firstName = true;
      res.error = true;
    }

    if (res.lastName.length < 3 && !(allowEmpty && res.lastName == "")) {
      res.error_lastName = true;
      res.error = true;
    }

    if (res.password.length < 6 && !(allowEmpty && res.password == "")) {
      res.error_password = true;
      res.error = true;
    }

    if (res.password2 != res.password && !(allowEmpty && res.password2 == "")) {
      res.error_password2 = true;
      res.error = true;
    }

    setErrorFirstName(res.error_firstName);
    setErrorLastName(res.error_lastName);
    setErrorEmail(res.error_email);
    setErrorPassword(res.error_password);
    setErrorPassword2(res.error_password2);
    setErrorTelefonNumber(res.error_telefonNumber);

    // res.password = SHA256.hash(res.password).toString();
    delete res.password2;

    return res;
  }


  let headText = (
    <div>
      <div style={{ fontSize: "1.5em", fontWeight: "boldS" }}>Passe Dein Profil an</div>
    </div>
  );

  return (
    <div className="container" style={{ height: "100vh", display: "flex", flexDirection: "column", padding: "20px", paddingBottom: "100px" }}>
      {(enableBack || imageSrc) && <div style={{ color: "white", textAlign: "center" }}>
        <span style={{ fontSize: "1.5em" }}>Du kannst Dein Profilbild ändern </span>
        <br />
        <br />
        {avatarEditActive &&
          <div style={{ fontSize: "1em" }}>
            Du kannst das Bild zoomen und verschieben
            <br />
            <br />
          </div>}
        {!avatarEditActive &&
          <span style={{ fontSize: "1em" }}>
            Tippe auf das Bild, <br />
            um es bearbeiten
          </span>}

      </div>
      }


      {!enableBack && !imageSrc && <div style={{ color: "white", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span style={{ fontSize: "1.5em" }}>Du hast noch keine Profilbild</span>
        <br />
        <span style={{ fontSize: "1em" }}>
          Erstelle es jetzt ...
        </span>

        <div style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "max-content",
        }}>

          <br />
          <br />

          <div
            style={{
              borderRadius: "30px",
              backgroundColor: "orange",
              padding: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
              cursor: "pointer",
            }}
            onClick={() => {
              const imageLoad = document.getElementById("imageLoad");
              imageLoad?.click();
            }}
          >
            Mit der Kamara aufnehmen
          </div>

          <br />

          <div
            style={{
              borderRadius: "30px",
              backgroundColor: "orange",
              padding: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
              cursor: "pointer",

            }}
            onClick={async () => {
              const imageLoadFile = document.getElementById("imageLoadFile");
              imageLoadFile?.click();
            }}
          >
            Aus der Galerie auswählen
          </div>
        </div>




      </div>
      }

      {!imageSrc && <div>
        <br />
        <br />
      </div>}

      {imageSrc && <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column",

          alignItems: "center",

          flexGrow: "1",
          justifyContent: "center",
        }}
      >
        {!avatarEditActive && (
          <div style={{ position: "relative", width: "150px" }}>
            <img
              crossOrigin="anonymous"
              key={`f-${imageNotFound}`}
              src={imageNotFound ? "images/gost.png" : imageAdjustedSrc}
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "75px",
                objectFit: "cover",
              }}
              onError={() => {
                setImageNotFound(true);
                setImageLoadedFromServer(false);
              }}
              onClick={() => {
                if (imageSrc && !imageNotFound && !imageLoadedFromServer) {
                  setAvatarEditActive(true);
                } else {
                  const imageLoad = document.getElementById("imageLoad");
                  imageLoad?.click();
                }
              }}
            />

            <div
              style={{
                width: "30px",
                height: "30px",
                position: "absolute",
                right: "0px",
                bottom: "0px",
                borderRadius: "15px",
                backgroundColor: "orange",
              }}
              onClick={() => {
                const imageLoad = document.getElementById("imageLoad");
                imageLoad?.click();
              }}
            >
              <FontAwesomeIcon
                style={{
                  color: "#444",
                  fontSize: "0.75rem",
                  paddingLeft: "9px",
                  paddingTop: "9px",
                }}
                icon={faCamera}
              />
            </div>

            <div
              style={{
                width: "30px",
                height: "30px",
                position: "absolute",
                left: "0px",
                bottom: "0px",
                borderRadius: "15px",
                backgroundColor: "orange",
              }}
              onClick={() => {
                const imageLoadFile = document.getElementById("imageLoadFile");
                imageLoadFile?.click();
              }}
            >
              <FontAwesomeIcon
                style={{
                  color: "#444",
                  fontSize: "0.75rem",
                  paddingLeft: "9px",
                  paddingTop: "9px",
                }}
                icon={faList}
              />
            </div>
          </div>
        )}

        {avatarEditActive && <ProfilePictureEditor imageSrc={imageSrc} setImageAdjustedSrc={setImageAdjustedSrc} setAvatarEditActive={setAvatarEditActive} />}
      </div>}

      {!avatarEditActive && (
        <div>
          {/* <div className="form-row">
              <div className="input-data">
                <input
                  id="firstName"
                  type="text"
                  required
                  autoComplete="name"
                  placeholder="Vorname"
                  onBlur={() => {
                    const d1 = getData(true);
                    setInitials((d1.firstName || "?").substring(0, 1) + (d1.lastName || "?").substring(0, 1));
                  }}
                />
                <div className={`underline ${errorFirstName ? "error" : ""}`}></div>
                <label>Vorname</label>
              </div>
            </div>

            <div className="form-row">
              <div className="input-data">
                <input
                  id="lastName"
                  type="text"
                  required
                  placeholder="Nachname"
                  autoComplete="family-name"
                  onBlur={() => {
                    const d1 = getData(true);
                    setInitials((d1.firstName || "?").substring(0, 1) + (d1.lastName || "?").substring(0, 1));
                  }}
                />
                <div className={`underline ${errorLastName ? "error" : ""}`}></div>
                <label>Nachname</label>
              </div>
            </div>

            <div className="form-row">
              <div className="input-data">
                <input
                  id="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="Email Adresse"
                  onBlur={() => {
                    const d = getData(true);
                  }}
                />
                <div key={`email-${errorEmail}`} className={`underline  ${errorEmail ? "error" : ""}`}></div>
                <label>Email Adresse</label>
              </div>
            </div>
            <div className="form-row">
              <div className="input-data">
                <input
                  placeholder="Mobile Telefonnummer"
                  id="telefonNumber"
                  type="tel"
                  required
                  autoComplete="tel"
                  onBlur={() => {
                    const d = getData(true);
                  }}
                />

                <div key={`tel-${errorTelefonNumber}`} className={`underline  ${errorTelefonNumber ? "error" : ""}`}></div>

                <label>Mobile Telefonnummer</label>
              </div>
            </div> */}

          {/* <div className="form-row" style={{ marginTop: "60px" }}>
              <div className="input-data">
                <PasswordInput key="pw" placeholder="Passwort" id="password" error={errorPassword} />
              </div>
            </div>

            <div className="form-row">
              <div className="input-data">
                <PasswordInput key="pw2" placeholder="Passwort Wiederholung" id="password2" error={errorPassword2} />
              </div>
            </div> */}

          <div className="form-row" style={{
            display: "flex",
            flexDirection: "row",
            paddingBlockStart: "20px",
            paddingTop: "20px",
            width: "100%"
          }}>

            <div className="input-data" style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              width: "100%",
              marginLeft: "10px",
              marginRight: "10px",

            }}>
              {!enableBack && <a
                href="#"
                style={{ color: "#ccc" }}
                onClick={() => {
                  window.location.pathname = "booking";
                }}>
                Ohne Profilbild weiter
              </a>}


              {enableBack && <button
                className="button buttonOrange"
                style={{
                  padding: "7px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "40px",
                  borderRadius: "20px",
                }}
                onClick={async (ev) => {
                  window.location.href = "/";
                }}
              >
                Zurück
              </button>}

              <button
                className="button buttonOrange"
                disabled={imageLoadedFromServer || imageNotFound}
                style={{
                  float: "right",
                  padding: "7px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "40px",
                  borderRadius: "20px",
                }}
                onClick={async (ev) => {
                  const user = JSON.parse(common.getUserFromLocalStorage());

                  await ServerInterface.saveProfileImage({ memberId: user.memberId, img: imageAdjustedSrc });
                  window.location.href = "/";
                }}
              >
                Speichern
              </button>
            </div>
          </div>


          {/* <div style={{ color: "darkgrey", fontSize: "0.7em" }}>
            orgId={orgId} &nbsp; userId={userId} &nbsp: mode={mode}
          </div> */}
        </div>
      )}

      <input id="imageLoad" style={{ visibility: "hidden", position: "absolute" }} type="file" accept="image/*" capture="user" onChange={onImageLoadChange} />

      <input id="imageLoadFile" style={{ visibility: "hidden", position: "absolute" }} type="file" accept="image/*" onChange={onImageLoadChange} />
    </div>
  );
}

async function convertImage(src: string): Promise<string> {
  let blob = await fetch(src).then((r) => r.blob());
  let dataUrl = await new Promise<string>((resolve) => {
    let reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });

  return dataUrl;
}

async function resizeImage(url: string, width: number, height: number): Promise<string> {
  let dataUrl = await new Promise<string>((resolve) => {
    var sourceImage = new Image();

    sourceImage.onload = function () {
      // Create a canvas with the desired dimensions
      var canvas = document.createElement("canvas") as HTMLCanvasElement;
      canvas.width = width;
      canvas.height = height;

      let fh = sourceImage.width / sourceImage.height;
      let fw = 1;
      if (fh > 1) {
        fw = fh;
        fh = 1;
      }
      // Scale and draw the source image to the canvas
      canvas.getContext("2d")?.drawImage(sourceImage, 0, 0, width * fw, height / fh);

      // Convert the canvas to a data URL in PNG format
      resolve(canvas.toDataURL());
    };
    sourceImage.src = url;
  });

  return dataUrl;
}
